<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Paiements vendeurs",
          icon: "bi bi-cash-stack",
          route: "seller-payments-index",
        },
        {
          label: "Nouveau paiement",
          icon: "bi bi-wallet2",
          route: "seller-payments-create",
        },
      ],
    };
  },
};
</script>
